import { Language } from './language';

export const English: Language = {
    loadingDescription: 'Loading templates...',
    addToCart: 'ADD TO CART',
    bodyColor: 'choose body color',
    bedBodyColor: 'choose body color',
    countertopColor: 'choose countertop color',
    frontColor: 'choose doors color',
    altFrontColor: 'choole fronts color',
    shelfColor: 'choose shelves color',
    wallColor: 'choose partitions color',
    bedWallColor: 'choose bedhead color',
    handles: 'choose handles',
    legs: 'choose legs',
    longLegs: 'choose legs',
    frame: 'choose frame',
    undo: 'Undo',
    redo: 'Redo',
    toggleFronts: 'Show/hide fronts',
    removeElement: 'Remove',
    center: 'Center',
    changeHandlePosition: 'Rotate',
    elements: 'elements',
    search: 'Search...',
    width: 'width',
    height: 'height',
    depth: 'depth',
    currency: 'zł',
    colorAll: 'color all',
    colorSelected: 'color selected',
    saveProject: 'save project',
    addToVoxBox: 'add to VOXBOX',
    gotoTop: 'to top',
    noSlotsAvailable: 'You don\'t have space for this element of the interior',
    projectSaved: 'Project saved',
    addedToVoxbox: 'Added to VOXBOX',
    addedToCart: 'Added to card',
    addElements: 'add elements',
    chooseTemplate: 'choose template',
    addFronts: 'add fronts',
    saveProjectSplited_0: 'save',
    saveProjectSplited_1: 'your furniture',
    addToVoxBoxSplited_0: 'add to',
    addToVoxBoxSplited_1: 'VOXBOX',
    addedWall: 'To provide a safe construction of the furniture we have added a partition',
    addedSupport: 'To ensure the safe construction of the furniture we have added a reinforcing strip',
    hideFronts: 'We\'ve hidden the door so that you can add interior elements. If you want to see them again, use the HOW/HIDE FRONTS button',
    woodenElementsDisabled: 'Not all color combinations of wooden elements go well together. For your convenience, we have blocked connections that will not match',
    noElements: 'There is not a single element of this kind in your furniture',
    loadingScene: 'loading scene',
    resetColors: 'reset colors',
    resetModel: 'start over',
    resetModelSplitted_0: 'start',
    resetModelSplitted_1: 'over',
    loadingProductError: 'error occured during fetching furniture data',
    retry: 'retry',
    unifyWoodColors: 'The wood color you want to choose does not match the ones previously used in your furniture.\n\n\nSelecting this color will change all wood elements to this color.\n\n\nIf you want to do this, click again.',
    unifyWoodColorsSplitted_0: 'STYLIST TIP',
    unifyWoodColorsSplitted_1: 'Not all wood colors work together. The selected color does not match the colors previously used in your furniture.',
    unifyWoodColorsSplitted_2: 'Click again to change all wooden elements to a new shade of wood.',
    noFronts: 'Furniture has no fronts.',
    noElementsSelected: 'There are no elements selected',
    toggleFrontsOpen: 'show doors',
    toggleFrontsClose: 'hide doors',
    altToggleFrontsOpen: 'show fronts',
    altToggleFrontsClose: 'hide fronts',
    shareProject_0: 'share',
    shareProject_1: 'project',
    tooLongFrontForDrawer: 'You can not add a drawer - the door will not allow it too long. Remove the door and add its shorter variant.',
    hangersReserveSomeSpace: 'The hanger reserves some space under it. Remove the hanger if you want to add drawers under it',
    drawersDoNotHideBehindFronts: 'Drawers do not hide behind doors. Delete them or choose a smaller door.',
    doubleDoorsDoNotFitInFrontOfVerticalWalls: 'The vertical partition prevents double doors. Use a single door or remove a partition and insert a double.',
    doubleDoorsDoNotFitTrySinglwDoors: 'Double doors cannot be added. Try to use a single version of them.',
    singleDoorsDoNotFitTryDoubleDoors: 'Single doors cannot be added. Try to use a double version of them.',
    doorBlockedByHorizontalWall: 'Remove the partition or choose a smaller door.',
    drawersDoNotFitBetweenShelf: 'Remove shelf to add drawers.',
    tooltipDelete: 'Select the item you want to delete',
    createYourOwn: 'create your own',
    lack: 'lack',
    deliveryIn_0: 'Delivery in',
    deliveryIn_1: 'working days',
    quantity: 'quantity',
    //colors
    white: 'white',
    gray: 'gray',
    black: 'black',
    nude: 'nude',
    green: 'green',
    indigo: 'indigo',
    saffron: 'saffron',
    lightOak: 'light oak',
    honneyOak: 'honney oak',
    brownOak: 'brown oak',
    darkOak: 'dark oak',
    //elements
    shortShelf: 'short shelf 42,5 cm',
    longShelf: 'long shelf 88 cm',
    shortHanger: 'short hanger 42,5 cm',
    longHanger: 'long hanger 88 cm',
    shortDrawer: 'short drawers 42,5 cm',
    longDrawer: 'long drawers 88 cm',
    front1x1: '45x45',
    front1x2: '45x90',
    front1x3: '45x135',
    front1x4: '45x180',
    front2x1: 'double 45x45',
    front2x2: 'double 45x90',
    front2x3: 'double 45x135',
    front2x4: 'double 45x180',
    bedsideTableDrawer: 'drawer 1x1',
    deskShortDrawer: 'drawer 1x1',
    deskLongDrawer: 'drawer 2x1',
    dressingShortDrawer: 'drawer 1x1',
    dressingLongDrawer: 'drawer 2x1',
    //handles
    push: 'push',
    oakTrapeze: 'oak trapeze',
    metalCylinder: 'metal cylinder',
    metalTHandle: 'metal T handle',
    leatherHandle: 'leather handle',
    metalKnobLight: 'metal knob',
    oakCylinder: 'oak cylinder',
    metalKnobDark: 'metal knob',
    metalWireLight: 'metal wire',
    oakStraightHandle: 'oak straight handle',
    metalWireDark: 'metal wire',
    metalStraightHandle: 'metal straight handle',
    //legs
    supportLegs: 'support',
    oakStraightLegs: 'oak straight leg',
    metalLegs: 'metal leg',
    metalSkid: 'metal skid',
    sliderLegs: 'slider',
    woodenBrownObliqueFrameLegs: 'wooden oblique frame',
    metalBentFrameLegs: 'metal bent frame',
    metalStraightFrameLegs: 'metal straight frame',
    metalObliqueFrameLegs: 'metal oblique frame',
    oakObliqueFrameLegs: 'oak oblique frame',
    woodenBlackObliqueFrameLegs: 'wooden oblique frame',
    woodenConeLegs: 'wooden cone leg',
    oakCylinderLegs: 'oak cylinder leg',
    tooltipSmallDrower_0: 'Mała szuflada',
    tooltipSmallDrower_1: 'Mała szuflada',
    productModalDescription: 'TODO',
    yes: 'yes',
    no: 'no',
    depthAbbreviation: 'd',
    widthAbbreviation: 'w',
    heightAbbreviation: 'h',
    dimension: 'dimension',
    summaryDrawers: 'drawers',
    summaryHangers: 'hangers',
    summaryBodyColor: 'body color',
    summaryShelfColor: 'shelf color',
    summaryBarColor: 'wall color',
    summaryBedHeadColor: 'bed head color',
    summaryFrontsColor: 'fronts color',
    summaryFrontsColor2: 'fronts color',
    summaryLegs: 'legs',
    summaryHandles: 'handles',
    summaryFrame: 'frame',
    //frames
    liftedFrame: 'lifted frame',
    floorFrame: 'floor',
    floorWithFlexibleSlats: 'floor with flexible slats',
    productModalWarning: 'Warning!',
    productModalDescriptionWarning: 'TODO',
};
